// The routes, built from screens.ts. Each page loads when it is first opened (React.lazy). An unknown URL goes
// back to the overview.
import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { TableSkeleton } from '@the-kit/ui'
import { ROUTES } from '@/constants/routes'
import { ScreenElement } from './ScreenElement'
import { GALLERY_SCREEN, SCREENS } from './screens'

export function AppRoutes() {
  const screens = import.meta.env.DEV ? [...SCREENS, GALLERY_SCREEN] : SCREENS
  return (
    <Suspense fallback={<TableSkeleton />}>
      <Routes>
        {screens.map((screen) => (
          <Route key={screen.path} path={screen.path} element={<ScreenElement screen={screen} />} />
        ))}
        <Route path="*" element={<Navigate to={ROUTES.overview.to()} replace />} />
      </Routes>
    </Suspense>
  )
}
